import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AlertService, UserService } from '../_services/index';
import { environment } from '../../environments/environment';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    moduleId: module.id.toString(),
    templateUrl: 'forgotpassword.component.html'
})

export class ForgotPasswordComponent {
    model: any = {};
    loading = false;

    constructor(
        private router: Router,
        private userService: UserService,
        private alertService: AlertService) { }

    fpassword() {
        this.loading = true;
        this.userService.resetPasswordRequest(this.model.username, environment.client_origin)
            .subscribe(
                data => {
                  // alert(JSON.stringify(data));
                    this.alertService.success(data.message, true, 8000);
                    this.router.navigate(['/login']);
                },
                (error: HttpErrorResponse) => {
                    console.log(`Error: ${error}`);
                    this.alertService.error(error.error.message);
                    this.loading = false;
                });
    }
}
